import { IonContent } from "@ionic/react"

const Blank: React.FC = () => { 
    return (
        <IonContent class="signin-page">
            <div></div>
        </IonContent>
    )
}
export default Blank